module.exports = __webpack_public_path__ + "img/logoBlue.e0b49d16.png";